module.exports = {"id":"32740","name":"Johan Wiland","rating":"72","photo":"./data/images/photos/4/32740.png","club":{"name":"Hammarby IF","logo":"./data/images/clubs/HammarbyIF.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JohanWiland0.json
// module id = 2068
// module chunks = 0